import React from 'react';
import { useContentByComponentKey } from '@ynap/content-hook';
import Overlay from '@ynap/overlay';
import BEMHelper from '@ynap/bem-helper';
import PropTypes from 'prop-types';

const bem = new BEMHelper('ShippingRestrictionsModal');

const ShippingRestrictionsModal = (props) => {
    const { closeModal, goBack } = props;

    const getShippingRestrictions = (shippingRestrictions) => {
        if (!shippingRestrictions) {
            return {};
        }

        const getList = (items) => {
            return (
                items &&
                items.reduce((acc, item) => {
                    if (item.teaser) {
                        acc.push({
                            title: item.teaser?.teaserTitle,
                            content: item.teaser?.teaserTextPlain,
                        });
                    }
                    return acc;
                }, [])
            );
        };
        return {
            title: shippingRestrictions?.content?.[0]?.teaserTitle,
            content: getList(shippingRestrictions?.content?.[0]?.items),
        };
    };

    const { content: { title: modalTitle, content: modalContent } = {} } = useContentByComponentKey({
        componentKey: 'help-shipping-restrictions',
        normalize: getShippingRestrictions,
    });

    const closeShippingRestrictionsModal = () => {
        return closeModal(null);
    };

    const className = {
        container: bem('container'),
        content: bem('content'),
    };

    return (
        <Overlay
            className={className}
            onClose={closeShippingRestrictionsModal}
            handleBodyClick={closeShippingRestrictionsModal}
            title={modalTitle}
            goBack={goBack}
        >
            <ul>
                {modalContent &&
                    modalContent.map((item) => {
                        return (
                            <li key={item.title}>
                                <h4 className={bem('subTitle')}>{item.title}</h4>
                                <p>{item.content}</p>
                            </li>
                        );
                    })}
            </ul>
        </Overlay>
    );
};

ShippingRestrictionsModal.propTypes = {
    closeModal: PropTypes.func.isRequired,
    goBack: PropTypes.func,
};

export default ShippingRestrictionsModal;
